// extracted by mini-css-extract-plugin
module.exports = {"option":"option_option__ST__Y"};